export default {
  path: '/forms',
  name: 'forms',
  component: () => import(/* webpackChunkName: "forms" */ './Forms'),
  props: true,
  meta: {
    requiresAuth: true
  }
}
